/* tslint:disable:indent */
/*
 * Copyright (c) 2014-2024 Comparatio USA  LLC. <https://www.comparatio.com>
 */

import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {GeneralService} from './general.service';
import {Injectable} from '@angular/core';
import { Page } from 'app/model/page';

@Injectable()
export class OrderConfirmationRunTimeService extends GeneralService {

	constructor(
		protected http: HttpClient
	) {
		super(http);
	}

	public getDataList(page: Page): Observable<any> {
		const url = '/order-confirmation-run-time';
		return this.getRestList(page, url);
	}

	filterResultsList(page: Page) {
		const url = '/order-confirmation-run-time/date-range-filter';
		return this.getRestList(page, url);
	}

	public runReport(page: Page) {
		const url = '/order-confirmation-run-time/run-report';
		return this.getRestList(page, url);
	}

	public initialize() {
		return {
			ED1_ID: null,
			ED1_LOG_ID: null,
			COMPANY_NAME: null,
			CUSTOMER_NAME: null,
			ED1_TYPE: null,
			ED1_DOC_NO: null,
			LOG_DATE_TIME: null,
			CONTAINER_NAME: null,
			SCOPE_NAME: null,
			CONTEXT_ID: null,
			MESSAGE_TYPE: null,
			API_NAME: null,
			API_URL: null,
			EDI_LOG_ID: null,
			LOG_MESSAGE: null,
			DURATION: null
		};
	}

	public initializeDates () {
		return {
			DATE1 : '',
			DATE2 : '',
		};
	}

    public initializeCompany () {
        return {
            CO1_ID : null,
        };
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/services/order-confirmation-run-time.service.ts